"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _i18n = require("../../../../Framework/i18n");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable prettier/prettier */
var styles = function styles(theme) {
  var _MuiFormControlRoot, _checkboxLabel, _checkbox;
  return {
    MuiFormControlRoot: (_MuiFormControlRoot = {
      display: 'flex !important'
    }, _defineProperty(_MuiFormControlRoot, theme.breakpoints.up('sm'), {
      marginTop: 15,
      marginBottom: 20
    }), _defineProperty(_MuiFormControlRoot, '& label', {
      fontSize: 15
    }), _MuiFormControlRoot),
    checkboxLabel: (_checkboxLabel = {
      fontSize: 15,
      paddingTop: 10,
      paddingLeft: 11,
      paddingBottom: 20
    }, _defineProperty(_checkboxLabel, theme.breakpoints.down('xs'), {
      paddingLeft: 2
    }), _defineProperty(_checkboxLabel, "alignItems", 'start'), _checkboxLabel),
    checkbox: (_checkbox = {
      marginRight: '10px'
    }, _defineProperty(_checkbox, theme.breakpoints.down('xs'), {
      margin: '-12px 0 0 10px'
    }), _defineProperty(_checkbox, "padding", '0'), _checkbox),
    formHelperText: {
      marginLeft: 45,
      marginBottom: 15
    }
  };
};
var AcceptDesign = /*#__PURE__*/function (_React$Component) {
  _inherits(AcceptDesign, _React$Component);
  var _super = _createSuper(AcceptDesign);
  function AcceptDesign() {
    _classCallCheck(this, AcceptDesign);
    return _super.apply(this, arguments);
  }
  _createClass(AcceptDesign, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        noteLabel = _this$props.noteLabel,
        notice = _this$props.notice,
        handleChange = _this$props.handleChange,
        handleChangeCheckboxApproval = _this$props.handleChangeCheckboxApproval,
        approval = _this$props.approval,
        displayAcceptDesign = _this$props.displayAcceptDesign,
        termsAndConditionsLink = _this$props.termsAndConditionsLink;
      var termsLink = "<a href=\"".concat(termsAndConditionsLink, "\"\n                              target=\"_blank\">").concat((0, _i18n.t)('acceptDesignScreen.termsAndConditionsLinkLabel'), "</a>");
      var termsAndConditions = termsAndConditionsLink ? ' ' + (0, _i18n.t)('acceptDesignScreen.termsAndConditions', {
        termsAndConditionsLink: termsLink
      }) : '';
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        label: noteLabel,
        multiline: true,
        rows: "3",
        rowsMax: "3",
        value: notice,
        onChange: handleChange,
        margin: "normal",
        variant: "outlined",
        classes: {
          root: classes.MuiFormControlRoot
        }
      })), displayAcceptDesign && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        className: classes.checkboxLabel,
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          name: "approval",
          checked: approval.value,
          onChange: handleChangeCheckboxApproval,
          color: "primary",
          className: classes.checkbox
        }),
        label: /*#__PURE__*/_react["default"].createElement("span", {
          dangerouslySetInnerHTML: {
            __html: (0, _i18n.t)('acceptDesignScreen.checkedSelectionActive') + termsAndConditions
          }
        })
      }), approval.error && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
        error: true,
        className: classes.formHelperText
      }, (0, _i18n.t)('acceptDesignScreen.selectionError'))));
    }
  }]);
  return AcceptDesign;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'AcceptDesign'
})(AcceptDesign));